import { StyledListItemCountry, StyledTag } from "./styles";

type Props = {
    countryCode: number;
    text?: string;
    className?: string;
};

const StyledSignalCountryTag = ({ countryCode, text, className }: Props) => {
    return (
        <StyledTag className={className}>
            <StyledListItemCountry
                countryCode={countryCode}
                text={text}
            />
        </StyledTag>
    );
};

export default StyledSignalCountryTag;
